import { graphql } from "gql.tada";

export const TagFragment = graphql(`
  fragment TagFragment on Tag {
    tagLabel
    slug
  }
`);
